import React from 'react';
import { Button } from '../ui/button';
import { BellRing, Check } from 'lucide-react';
import { timeAgo } from './vigilanciaUtils';

const TIPO_CLS = {
  diario: 'bg-sky-100 text-sky-800',
  mensual: 'bg-indigo-100 text-indigo-800',
  saldo: 'bg-rose-100 text-rose-800',
};

export const AlertaRow = ({ a, onAtender, onVer, prefix = 'vig' }) => (
  <div className="flex flex-wrap items-center gap-2 bg-white rounded-lg border border-rose-100 px-3 py-2 text-sm" data-testid={`${prefix}-alerta-${a.id}`}>
    <span className={`text-[11px] font-semibold px-2 py-0.5 rounded ${TIPO_CLS[a.tipo] || 'bg-slate-100'}`}>{a.tipo_label}</span>
    <span className="font-semibold text-slate-800 truncate max-w-[220px]">{a.nombre}</span>
    <span className="text-xs text-slate-600 flex-1 min-w-[200px]">{a.mensaje}</span>
    <span className="text-[11px] text-slate-400">{timeAgo(a.created_at)}</span>
    {onVer && <Button size="sm" variant="ghost" className="h-7 text-rose-700" onClick={onVer} data-testid={`${prefix}-alerta-ver-${a.id}`}>Ver</Button>}
    <Button size="sm" variant="outline" className="h-7 border-rose-200 text-rose-700 hover:bg-rose-50" onClick={() => onAtender(a)} data-testid={`${prefix}-alerta-atender-${a.id}`}>
      <Check size={13} className="mr-1" /> Atender
    </Button>
  </div>
);

export const AlertasPanel = ({ alertas, onAtender }) => {
  if (!alertas.length) return null;
  return (
    <div className="rounded-2xl border border-rose-200 bg-rose-50/70 p-4" data-testid="vig-alertas-panel">
      <p className="flex items-center gap-2 text-sm font-bold text-rose-800 mb-3">
        <span className="relative flex h-2.5 w-2.5"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-rose-400 opacity-75" /><span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-rose-600" /></span>
        <BellRing size={15} /> {alertas.length} alerta{alertas.length > 1 ? 's' : ''} activa{alertas.length > 1 ? 's' : ''}
      </p>
      <div className="space-y-1.5 max-h-64 overflow-y-auto">
        {alertas.map((a) => <AlertaRow key={a.id} a={a} onAtender={onAtender} />)}
      </div>
    </div>
  );
};

export default AlertasPanel;
